import { PLATFORM_ID, inject, REQUEST } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';

export function browserLanguageFactory(): string {
  const platformId = inject(PLATFORM_ID);
  const defaultLanguage = 'no';

  if (isPlatformBrowser(platformId)) {
    return navigator.language?.split('-')[0] || defaultLanguage;
  } else {
    const req = inject(REQUEST, { optional: true });
    const userLangLocation = req?.headers?.get('accept-language')?.split(',')[0] || defaultLanguage;
    return userLangLocation.split('-')[0] || defaultLanguage;
  }
}
